var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('treeselect',{staticClass:"mt-5 mb-2",attrs:{"placeholder":"Порода дерева","multiple":"","options":_vm.breedsRemade},on:{"input":_vm.passDataChild},model:{value:(_vm.breedId),callback:function ($$v) {_vm.breedId=$$v},expression:"breedId"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }